<template>
    <div style="height: 100% ; ">
        <div style="height: 100%;background: #FFFFFF; overflow: hidden;
box-shadow: 0px 2px 14px 0px rgba(0,0,0,0.12);display: flex;justify-content: center;"  v-if="newDialog">
                <div  class=" newHhuokeBox  margin-top20" style="height: 100%">
         <div class="newHuo-left">
   <div class="newHuo-left-box">
                    <h3 class="newHuo-left-head margin-top20 margin-bottom30"> Search Leads</h3>
                    <div class="newHuo-left-head_text margin-bottom20" style="padding: 0px;">
                        Search Leads is a powerful tool designed to help business users connect with potential customers or vendors. Driven by cutting-edge machine learning technology, our platform analyzes extensive datasets to deliver tailored and precise recommendations.
                    </div>
                    <div class="newHuo-left-head_text  margin-bottom20" style="padding: 0px;">
                        The system takes into account user goals, market trends, risk tolerance, and historical data to pinpoint products or services that best match their specific needs and preferences. 
                    </div>
                    <div class="newHuo-left-head_text margin-bottom20" style="padding: 0px;">
                        Continuously learning and evolving, "Search Leads" ensures its recommendations remain relevant and accurate. By offering actionable insights, it empowers businesses to save time and resources while identifying the most promising customers or vendors.
                    </div>
                    <div class="newHuo-left-head_text margin-bottom20" style="padding: 0px;">
                        <!-- v-if="questionsNum==3" -->
                        In order for the system to recommend a list of companies, we need you to answer few questions.
                    </div>

                </div>
                  <div class="flex_center_star">
                <el-button class="btn_export btn_exportYell riskButton" @click="onSubmitkoudian()"><span
                   >Let's Begin</span></el-button>
            </div>
         </div>
           <div class="newHuo-right">
            <img src="../../../assets/dialogIcoImg/newHuoke.png" alt="">
         </div>
        </div>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        suoClose: {
            type: Boolean,
        },

    },
    data() {
        return {
            //page: this.currentPage
            questionsNum: 0,
            token: localStorage.getItem('token'),
        };
    },
    computed: {
        newDialog: {
            get() {
                return this.suoClose;
            },
            set() { },
        },

    },
    destroyed() {
        // bus.$off('handleShowLogin');
    },
    methods: {
        //关闭弹窗
        closeDialog() {
            this.$emit('closeCloseDialog', false);
        },
        onSubmitkoudian() {
            if(this.token){
                this.$emit('closeCloseDialog', false);

            }
            else{
                this.$parent.$parent.loginDialog=true
            }
        },
        onSubmitquxiao() {
        },
    },
};
</script>
<style scoped>
.detail_cont {
    max-height: 85vh;
    overflow: auto;
    min-height: 216px;
    margin-bottom: 2.14285714rem;
}



.btn_exportYell {
    background: #8E86DD !important;
    border-radius: 10px;
}
.dialog_normal_question-head{
    font-size: 1.857142857143rem;
    color: #1A2332;
    text-align: center;
}
.newHuo-right {
    width: 100%;
    text-align: right;
    position: relative;
    top: -11%;
}
.newHuo-right img{
    width:40%;
    height: 30%;
}
.newHuo-left{
    z-index: 999;
    position: relative;
     /* width: 58.5714rem; */
}
.newHhuokeBox{
    background-color: #fff;
    overflow: auto;
      width: 760px;
    background: #F5F5F5;
    min-height: 745px;
    border-radius: 20px;
    height: 95% !important;
    padding:  1.42857143rem 4rem;
    position: relative;
     scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; 

}
.newHhuokeBox::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.newHuo-left-head{
    font-size: 2.28571429rem !important;
        font-family: 'DMSans Bold';
}
.newHuo-left-head_text{
 font-size: 1.285713rem !important;
 line-height: 2.14285714rem !important
}
</style>
